import { render } from "./GlobalNav.vue?vue&type=template&id=dc9bda6e"
import script from "./GlobalNav.vue?vue&type=script&lang=js"
export * from "./GlobalNav.vue?vue&type=script&lang=js"

import "./GlobalNav.vue?vue&type=style&index=0&id=dc9bda6e&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__